import { MutationTree, GetterTree } from 'vuex'
import { IStateIndex } from '~/store/index'
import { IProductsRaw } from '~/assets/interfaces/products'

interface IState {
  backFromProductName: null | string
  catalogUrlBeforeLeave: null | string
  backFromCatalogName: null | string
  products: IProductsRaw | null
}

export const state = (): IState => ({
  products: null,
  backFromProductName: null,
  backFromCatalogName: null,
  catalogUrlBeforeLeave: null,
})

export const mutations: MutationTree<IState> = {
  setProducts(state: IState, val: IProductsRaw | null) {
    state.products = val
  },
  setBackFromProductName(state: IState, val: string | null) {
    state.backFromProductName = val
  },
  setBackFromCatalogName(state: IState, val: string | null) {
    state.backFromCatalogName = val
  },
  setCatalogUrlBeforeLeave(state: IState, val: string | null) {
    state.catalogUrlBeforeLeave = val
  },
}

export const getters: GetterTree<IState, IStateIndex> = {
  getProducts(state: IState): IProductsRaw | null {
    return JSON.parse(JSON.stringify(state.products))
  },
}
